import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { RolesService } from '@core/services/roles.service';

export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const rolesService = inject(RolesService);
  const router = inject(Router);

  const required: string | string[] | undefined =
    route.data?.['permission'] ?? route.data?.['role'];

  if (!required) {
    return true;
  }

  rolesService.loadPermissions();

  const allowed = Array.isArray(required)
    ? rolesService.hasAnyPermission(...required)
    : rolesService.hasPermission(required);

  return allowed ? true : router.parseUrl('/');
};
